module.exports = __webpack_public_path__ + "img/97.6f41b33b.jpg";